import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram, Youtube, ChevronUp, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { notificationService } from '../services/notificationService';

const Footer = () => {
  const quickLinks = [
    { name: 'Inicio', href: '#home' },
    { name: 'Servicios', href: '#services' },
    { name: 'Industrias', href: '#industries' },
    { name: 'Productos', href: '#products' },
    { name: 'Nosotros', href: '#about' },
    { name: 'Contacto', href: '#contact' }
  ];

  const services = [
    { name: 'Mantenimiento Industrial', href: '#services' },
    { name: 'Instalación y Montaje', href: '#services' },
    { name: 'Consultoría Técnica', href: '#services' },
    { name: 'Repuestos y Accesorios', href: '#products' },
    { name: 'Inspección y Certificación', href: '#services' },
    { name: 'Capacitación Técnica', href: '#services' }
  ];

  const industries = [
    { name: 'Industria Papelera', href: '#industries' },
    { name: 'Industria Pesquera', href: '#industries' },
    { name: 'Industria Alimentaria', href: '#industries' },
    { name: 'Agroindustria', href: '#industries' },
    { name: 'Industria Manufacturer', href: '#industries' }
  ];

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Youtube, href: '#', label: 'YouTube' }
  ];


  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };



  const handleSocialClick = (platform: string) => {
    const socialUrls = {
      'Facebook': 'https://www.facebook.com/atomiccorporation',
      'Twitter': 'https://www.twitter.com/atomiccorporation',
      'LinkedIn': 'https://www.linkedin.com/company/atomiccorporation',
      'Instagram': 'https://www.instagram.com/atomiccorporation',
      'YouTube': 'https://www.youtube.com/@atomiccorporation'
    };
    
    const url = socialUrls[platform as keyof typeof socialUrls];
    if (url) {
      window.open(url, '_blank');
    }
  };

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const formElement = e.target as HTMLFormElement;
    const emailInputElement = formElement.querySelector('input[type="email"]') as HTMLInputElement;
    const email = emailInputElement?.value;
    
    if (!email) {
      notificationService.warning('Email requerido', 'Por favor, ingrese su email para suscribirse.');
      return;
    }
    
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      notificationService.warning('Email inválido', 'Por favor, ingrese un email válido.');
      return;
    }
    
    notificationService.success('¡Suscripción exitosa!', `Te has suscrito a nuestro newsletter con el email: ${email}\n\nTe enviaremos las últimas noticias sobre soluciones industriales, ofertas especiales y tendencias del sector.`);
    
    // Clear the form
    if (emailInputElement) {
      emailInputElement.value = '';
    }
  };

  const handleContactClick = (type: string) => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLegalClick = (documentType: string) => {
    // In a real app, this would open the actual legal documents
    const legalContent = {
      'Política de Privacidad': `
        POLÍTICA DE PRIVACIDAD - ATOMIC CORPORATION
        
        1. INFORMACIÓN RECOLECTADA
        Recopilamos información personal que usted nos proporciona voluntariamente al contactarnos
        a través de nuestro sitio web, formulario de contacto o newsletter.
        
        2. USO DE LA INFORMACIÓN
        Utilizamos su información para:
        - Responder a sus consultas
        - Enviar información sobre nuestros servicios
        - Mejorar nuestros productos y servicios
        - Enviar nuestro newsletter (si se suscribe)
        
        3. PROTECCIÓN DE DATOS
        Nos comprometemos a proteger su información personal y a no compartirla
        con terceros sin su consentimiento, excepto cuando sea necesario para
        proporcionar nuestros servicios.
        
        4. COOKIES
        Nuestro sitio web utiliza cookies para mejorar su experiencia. Puede
        desactivar las cookies en la configuración de su navegador.
        
        Para más información, contáctenos en ventas@atomcorporations.com
      `,
      'Términos y Condiciones': `
        TÉRMINOS Y CONDICIONES - ATOMIC CORPORATION
        
        1. ACEPTACIÓN DE TÉRMINOS
        Al utilizar nuestro sitio web y servicios, usted acepta estos términos y condiciones.
        
        2. DESCRIPCIÓN DE SERVICIOS
        Atomic Corporation proporciona servicios industriales incluyendo:
        - Mantenimiento industrial
        - Instalación y montaje
        - Consultoría técnica
        - Repuestos y accesorios
        - Inspección y certificación
        - Capacitación técnica
        
        3. RESPONSABILIDADES DEL CLIENTE
        - Proporcionar información precisa
        - Utilizar los servicios según las especificaciones
        - Realizar los pagos en los plazos acordados
        
        4. RESPONSABILIDADES DE ATOMIC CORPORATION
        - Proporcionar servicios con estándares de calidad
        - Cumplir con los plazos acordados
        - Mantener confidencialidad de la información del cliente
        
        5. PROPIEDAD INTELECTUAL
        Todo el contenido del sitio web es propiedad de Atomic Corporation
        y está protegido por leyes de propiedad intelectual.
        
        6. LIMITACIÓN DE RESPONSABILIDAD
        Atomic Corporation no será responsable por daños indirectos, incidentales
        o consecuentes que surjan del uso de nuestros servicios.
        
        Para más información, contáctenos en ventas@atomcorporations.com
      `,
      'Política de Calidad': `
        POLÍTICA DE CALIDAD - ATOMIC CORPORATION
        
        1. COMPROMISO CON LA CALIDAD
        Atomic Corporation se compromete a proporcionar productos y servicios
        que cumplan y superen las expectativas de nuestros clientes.
        
        2. SISTEMA DE GESTIÓN DE CALIDAD
        Implementamos y mantenemos un sistema de gestión de calidad basado en:
        - Normas ISO 9001
        - Mejora continua
        - Satisfacción del cliente
        - Cumplimiento normativo
        
        3. OBJETIVOS DE CALIDAD
        - Mantener una tasa de satisfacción del cliente superior al 95%
        - Reducir las no conformidades en un 10% anual
        - Cumplir con los plazos de entrega en un 98% de los casos
        - Mantener certificaciones actualizadas
        
        4. GARANTÍA DE CALIDAD
        Todos nuestros productos incluyen:
        - Garantía del fabricante
        - Soporte técnico post-venta
        - Repuestos originales
        - Documentación de calidad
        
        5. MEJORA CONTINUA
        Revisamos regularmente nuestros procesos y servicios para:
        - Identificar oportunidades de mejora
        - Implementar acciones correctivas
        - Actualizar tecnologías y métodos
        - Capacitar a nuestro personal
        
        Para más información, contáctenos en ventas@atomcorporations.com
      `,
      'Preguntas Frecuentes': `
        PREGUNTAS FRECUENTES - ATOMIC CORPORATION
        
        1. ¿QUÉ SERVICIOS OFRECEN?
        Ofrecemos mantenimiento industrial, instalación y montaje, consultoría técnica,
        repuestos y accesorios, inspección y certificación, y capacitación técnica.
        
        2. ¿QUÉ INDUSTRIAS ATIENDEN?
        Trabajamos con industria papelera, pesquera, alimentaria, agroindustria
        y manufactura en general.
        
        3. ¿OFRECEN GARANTÍA?
        Sí, todos nuestros productos incluyen garantía del fabricante y nuestros
        servicios cuentan con soporte post-venta.
        
        4. ¿CUÁL ES EL TIEMPO DE ENTREGA?
        Para productos en stock, el tiempo de entrega es de 24-48 horas.
        Para productos especiales, el tiempo varía según disponibilidad.
        
        5. ¿ATIENDEN EMERGENCIAS?
        Sí, contamos con servicio de emergencias 24/7.
        Contacte al +51 953 759 419.
        
        6. ¿CUÉNTAN CON CERTIFICACIONES?
        Sí, contamos con certificaciones ISO 9001 y otras certificaciones
        específicas de cada industria.
        
        7. ¿DÓNDE ESTÁN UBICADOS?
        Nuestra oficina principal está en Av. Industrial 1234, Lima, Perú,
        con presencia en las principales ciudades industriales del país.
        
        Para más preguntas, contáctenos en ventas@atomcorporations.com
      `
    };
    
    const content = legalContent[documentType as keyof typeof legalContent];
    if (content) {
      const blob = new Blob([content], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const linkElement = document.createElement('a') as HTMLAnchorElement;
      linkElement.href = url;
      linkElement.download = `Atomic-Corporation-${documentType.replace(/\s+/g, '-')}.txt`;
      document.body.appendChild(linkElement);
      linkElement.click();
      document.body.removeChild(linkElement);
      window.URL.revokeObjectURL(url);
    }
  };

  return (
    <footer className="bg-secondary-900 text-white">
      {/* Main Footer Content */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2 flex flex-col items-center md:items-start text-center md:text-left">
            <div className="flex items-center mb-6 justify-center md:justify-start">
              <Link to="/" className="flex items-center">
                <img src="/logofooter.png" alt="Atomic Corporation" className="h-40 w-auto" />
              </Link>
            </div>

            {/* Social Links */}
            <div className="flex items-center space-x-4 justify-center md:justify-start">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <button
                    key={index}
                    onClick={() => handleSocialClick(social.label)}
                    aria-label={social.label}
                    className="w-10 h-10 bg-secondary-800 hover:bg-primary-600 rounded-full flex items-center justify-center transition-colors duration-200"
                  >
                    <Icon className="w-5 h-5" />
                  </button>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h4 className="text-lg font-bold mb-6">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-secondary-300 hover:text-primary-400 transition-colors duration-200 flex items-center group justify-center md:justify-start"
                  >
                    {link.name}
                    <ChevronUp className="w-4 h-4 ml-1 rotate-90 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="text-center md:text-left">
            <h4 className="text-lg font-bold mb-6">Servicios</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.href}
                    className="text-secondary-300 hover:text-primary-400 transition-colors duration-200 flex items-center group justify-center md:justify-start"
                  >
                    {service.name}
                    <ChevronUp className="w-4 h-4 ml-1 rotate-90 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div className="text-center md:text-left">
            <h4 className="text-lg font-bold mb-6">Industrias</h4>
            <ul className="space-y-3">
              {industries.map((industry, index) => (
                <li key={index}>
                  <Link
                    to={industry.href}
                    className="text-secondary-300 hover:text-primary-400 transition-colors duration-200 flex items-center group justify-center md:justify-start"
                  >
                    {industry.name}
                    <ChevronUp className="w-4 h-4 ml-1 rotate-90 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

      </div>

      {/* Bottom Footer */}
      <div className="border-t border-secondary-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-center">
            <div className="text-secondary-400 text-sm">
              © 2024 Atomic Corporation. Todos los derechos reservados.
            </div>
            <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-6 text-sm">
              <button
                onClick={() => window.location.href = '/privacy-policy'}
                className="text-secondary-400 hover:text-primary-400 transition-colors"
              >
                Política de Privacidad
              </button>
              <button
                onClick={() => window.location.href = '/terms-conditions'}
                className="text-secondary-400 hover:text-primary-400 transition-colors"
              >
                Términos y Condiciones
              </button>
              <button
                onClick={() => window.location.href = '/quality-policy'}
                className="text-secondary-400 hover:text-primary-400 transition-colors"
              >
                Política de Calidad
              </button>
              <button
                onClick={() => window.location.href = '/faq'}
                className="text-secondary-400 hover:text-primary-400 transition-colors"
              >
                Preguntas Frecuentes
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 bg-primary-600 hover:bg-primary-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 z-40"
        aria-label="Scroll to top"
      >
        <ChevronUp className="w-6 h-6" />
      </button>
    </footer>
  );
};

export default Footer;
